import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import LeftTree from './components/LeftTree'
import BillUseingModal from './components/BillUseingModal'
import DownSettingModal from './components/DownSettingModal'
import BillProduct from './components/BillProduct'
import BillPlan from './components/BillPlan'
import './components/bill.less'
import './index.less'

@Component({
  components: {
    LeftTree,
    BillUseingModal,
    DownSettingModal,
    BillProduct,
    BillPlan
  }
})
export default class BillSettings extends Vue {
  @Ref() billComponent: BillProduct | BillPlan
  @Prop() menuId: string

  billUseingvisible = false
  downloadSettingvisible = false
  isShow = false
  currentComp = ''
  notificationShow = false

  getTableList(value) {
    this.currentComp = value.bizCode
    this.isShow = true
    this.$nextTick(() =>{
      this.billComponent.loadTable(value)
      this.openNotification()
    })
  }

  openNotification() {
    if(!this.notificationShow){
      this.notificationShow = true
      this.$notification['info']({
        message: `${this.$t('page_bill_settings_form_action')}`,
        description: `${this.$t('page_bill_settings_click_action')}`,
      });
    }
  }

  genComp(name) {
    if (name.indexOf(',') !== -1) {
      return <bill-plan ref="billComponent"></bill-plan>
    } else {
      return <bill-product ref="billComponent" isShow={this.isShow}></bill-product>
    }
  }

  render() {
    return (
    <div class="billSetting-body">
      <a-layout style="height: 100%">
        <a-layout-sider width="260" style="background: #fff;" class="no-fix-sider">
          <div style="padding: 8px;">
            <left-tree menuId={this.menuId} onChange={(value) => this.getTableList(value)} />
          </div>
        </a-layout-sider>
        <div v-resize={'x'}></div>
        <a-layout-content style={{ paddingLeft: '8px', height: '100%'}}>
          {this.genComp(this.currentComp)}
        </a-layout-content>
      </a-layout>
    </div>
    )
  }
}

